import CheckCircleIcon from "../Icons/CheckCircleIcon";
import BlitzIcon from "../Icons/BlitzIcon";
import {useEffect, useState} from "react";

enum langKey {
    startTitle,
    startHeading,
    startMessage,
    loadingMessage,
}

export default function SicherungenScreen({sicherungen, doneFunction, language = 'de'}: {
    sicherungen: number,
    doneFunction: Function,
    language: string
}) {
    const [ladebalken, setLadebalken] = useState(0)

    useEffect(() => {
        if (sicherungen === 0b11111) {
            const timeoutIdLadebalken = setTimeout(() => setLadebalken(0.13), 1000);

            return () => clearTimeout(timeoutIdLadebalken);
        }
    }, [sicherungen]);
    useEffect(() => {
        if (ladebalken > 0) {
            if (ladebalken >= 1) {
                doneFunction(true);
            }
            const timeoutId = setTimeout(() => setLadebalken(ladebalken + 0.02), 80);

            return () => clearTimeout(timeoutId);
        }
    }, [ladebalken]);

    return <>
        {ladebalken > 0 && <Windowsfenster>
            <p className={'text-w98-black text-4xl'}>{text(langKey.loadingMessage, language)}...</p>
            <progress className={'w-7/8 bg-w98-white h-4'} value={ladebalken}/>
        </Windowsfenster>}
        {ladebalken === 0 && <Windowsfenster title={text(langKey.startTitle, language)}
                                             heading={text(langKey.startHeading, language)}
                                             message={text(langKey.startMessage, language)}
        />}
        {ladebalken === 0 && <div className={'absolute p-20 bottom-10 w-[1760px] flex flex-row gap-32 justify-center'}>
            <Sicherung all={sicherungen} sicherung={0b10000}/>
            <Sicherung all={sicherungen} sicherung={0b01000}/>
            <Sicherung all={sicherungen} sicherung={0b00100}/>
            <Sicherung all={sicherungen} sicherung={0b00010}/>
            <Sicherung all={sicherungen} sicherung={0b00001}/>
        </div>}
    </>
}


function Sicherung({all, sicherung}: { all: number, sicherung: number }) {
    if ((all & sicherung) === sicherung) {
        return <>
            <div
                className={'w-48 h-48  bg-w98-gray rounded-full border-8 border-w98-dark-gray flex justify-center items-center'}>
                <CheckCircleIcon className={'fill-w98-blue/75'} sizeInPixel={140}/>
            </div>
        </>
    } else {
        return <>
            <div
                className={'w-48 h-48  bg-w98-gray rounded-full border-8 border-w98-dark-gray flex justify-center items-center'}>
                <BlitzIcon className={'fill-w98-red blink'} sizeInPixel={140}/>
            </div>
        </>
    }
}

interface WindowsfensterProps {
    title?: string,
    heading?: string,
    message?: string,
    children?: React.ReactNode,
    className?: string,
}

export function Windowsfenster({title, heading, message, children, className}: WindowsfensterProps) {
    return <>
        <div className={'w-full h-5/6 flex items-center justify-center'}>
            <div
                className={'w-2/3 h-1/3 bg-w98-gray relative shadow-sm shadow-w98-white border border-w98-dark-gray ' + className}>
                <div className={'bg-gradient-to-r  from-w98-blue from-50% to-w98-blue/30 to-90% w-full h-12'}>
                    <p className={'text-w98-white text-3xl pl-4 pt-1'}>{title}</p>
                </div>
                <div className={'w-full flex flex-col gap-6 items-center justify-center h-[252px]'}>
                    {!children && <>
                        <span className={'font-bold text-4xl'}>{heading}</span>
                        <p className={'text-w98-black text-3xl text-center'}>{message}</p>
                    </>}
                    {children}
                </div>
            </div>
        </div>
    </>
}


function text(key: langKey, language: string): string {
    if (key === langKey.startTitle) {
        if (language === 'en') {
            return 'Warning';
        } else {
            return 'Warnung';
        }
    }
    if (key === langKey.startHeading) {
        if (language === 'en') {
            return 'Attention!';
        } else {
            return 'Achtung!';
        }
    }
    if (key === langKey.startMessage) {
        if (language === 'en') {
            return 'Fuses must be screwed in for correct operation.';
        } else {
            return 'Sicherungen müssen für korrekten Betrieb eingedreht werden.';
        }
    }
    if (key === langKey.loadingMessage) {
        if (language === 'en') {
            return 'Starting system components for synchronisation';
        } else {
            return 'Starte Systemkomponenten für Synchronisation';
        }
    }

    return '';
}